import Menu from "./components/Menu";
import { dB64 } from "../shared/Encriptacion";
import { Link, useNavigate } from "react-router-dom";
import { HEADERS_API } from "./NuevaGuia";
import { useState, useEffect} from "react";
import axios from "axios";
import { mostrarAviso} from "./components/Aviso";
import Aviso from "./components/Aviso";
import { ValidarSesion } from "../shared/Validaciones";
import { ListaDepartamentos, ListaDistritos, ListaProvincias } from "../shared/Ubigeo";

export default function NuevaDireccion(){
    // ======================================================================================================
    //#region HOOKS STATE
    // ======================================================================================================
    //ESTADOS DE REGISTRO
    const[tipoDireccion, setTipoDireccion] = useState("anexo");
    const[direccion, setDireccion] = useState("");
    const[ubigeo, setUbigeo] = useState("");
    const[dpto, setDpto] = useState("");
    const[prov, setProv] = useState("");
    const[dist, setDist] = useState("");
    //ESTADOS DE CONTENIDO

    //#endregion

    //ESTADOS DE VALIDACIÓN
    const[datosCompletos, setDatosCompletos] = useState(false);
    // ======================================================================================================
    //#region HOOKS EFFECT
    // ======================================================================================================
    useEffect(()=>{
        ValidarSesion();
    },[]);

    // Actualizar ubigeo y reestablecer inferiores al cambiar departamento, provincia o distrito de partida
    useEffect(()=>{
        if(dpto == ""){
            HandlerProv("");

        }else{
            HandlerProv("01");
        }
        HandlerUbigeo(`${dpto}${prov}${dist}`);
    },[dpto]);
    useEffect(()=>{
        if(prov == ""){
            HandlerDist("");
        }else{
            HandlerDist("01");
        }
        HandlerUbigeo(`${dpto}${prov}${dist}`);
    },[prov]);
    useEffect(()=>{
        HandlerUbigeo(`${dpto}${prov}${dist}`);
    },[dist]);

    useEffect(()=>{
        if(direccion == ""){
            HandlerDpto("");
        }
    },[direccion]);

    // VALIDAR QUE LOS DATOS ESTÉN COMPLETOS
    useEffect(()=>{
        try{
            if(direccion == "" || ubigeo == "" || tipoDireccion == ""){
                throw new Error();
            }
            HandlerDatosCompletos(true);
        }catch(error){
            HandlerDatosCompletos(false);
        }
    },[tipoDireccion, direccion, ubigeo]);
    //#endregion

    // ======================================================================================================
    //#region  HOOK NAVIGATE
    // ======================================================================================================
    const navigate = useNavigate();
    //#endregion


    // ======================================================================================================
    //#region HANDLERS
    // ======================================================================================================
    //ESTADOS DE REGISTRO
    const HandlerTipoDireccion = (valor) => setTipoDireccion(valor);
    const HandlerDireccion = (valor) => setDireccion(valor.toUpperCase());
    const HandlerUbigeo = (valor) => setUbigeo(valor);
    const HandlerDpto = (valor) => setDpto(valor);
    const HandlerProv = (valor) => setProv(valor);
    const HandlerDist = (valor) => setDist(valor);
    
    //ESTADOS DE CONTENIDO

    //#endregion

    //ESTADOS DE VALIDACIÓN
    const HandlerDatosCompletos = (valor) => setDatosCompletos(valor);
    //#endregion

    // ======================================================================================================
    //#region FUNCIONES
    // ======================================================================================================
    // FUNCIONES ASÍNCRONAS
    const registrarDireccion = async () => {
        try{
            let response = await axios.post(URL_INSERTAR_DIRECCION,{
                codigoUsuario: "",
                tipoDireccion: tipoDireccion,
                direccion: direccion,
                ubigeo: ubigeo
            },{
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.response.data);
            });
            navigate("/direcciones");
        }catch(error){
            mostrarAviso(error, 2500);
        }
    }
    // FUNCIONES COMPLEMENTARIAS

    //#endregion

    // ======================================================================================================
    //#region CONTENIDO
    // ======================================================================================================
    return(<>
    <Menu/>
    <Aviso/>
    <div className="container">
        <div className="row">
            <div className="col-12 py-2 border-bottom border-secondary text-secondary text-center text-md-start">
                <h2>{dB64(localStorage.getItem('r6'))}</h2>
            </div>
            <div className='col-12 p-3 text-secondary'>
                <Link className='' to={'/direcciones'}>
                    <button className='btn btn-secondary'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-return-left" 
                        viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5"/>
                        </svg>
                        <span className='mx-2'>Regresar</span>
                    </button>
                </Link>
            </div> 
            <div className='col-12 pb-2 fs-3 fw-semibold'>
                NUEVA DIRECCIÓN
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="direccion">Dirección</label>
                    <input onChange={e=>HandlerDireccion(e.target.value)} value={direccion} maxLength={150} type="text" className="form-control text-uppercase" id="direccion" autoComplete="off"/>
                </div>
                <div className="row p-3">
                    <div className="col-12 col-md-4 p-1">
                        <div className="form-floating">
                            <select disabled={direccion == ""} onChange={e=>HandlerDpto(e.target.value)} value={dpto} id="dpto-cliente" className="form-select" placeholder="Departamento">
                                <option value="">Seleccionar</option>
                                <ListaDepartamentos/>
                            </select>
                            <label htmlFor="dpto-cliente">Departamento</label>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 p-1">
                        <div className="form-floating">
                            <select disabled={direccion == ""} onChange={e=>HandlerProv(e.target.value)} value={prov} id="prov-cliente" className="form-select" placeholder="Provincia">
                                <option value="">Seleccionar</option>
                                <ListaProvincias departamento={dpto}/>
                            </select>
                            <label htmlFor="prov-cliente">Provincia</label>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 p-1">
                        <div className="form-floating">
                            <select disabled={direccion == ""} onChange={e => HandlerDist(e.target.value)} value={dist} id="dist-cliente" className="form-select" placeholder="Distrito">
                                <option value="">Seleccionar</option>
                                <ListaDistritos provincia={prov} departamento={dpto}/>
                            </select>
                            <label htmlFor="dist-cliente">Distrito</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="tipo-direccion">Tipo de dirección</label>
                    <select onChange={e=>HandlerTipoDireccion(e.target.value)} id="tipo-direccion" className="form-select text-capitalize">
                        <option value="anexo">Establecimiento anexo</option>
                        <option value="frecuente">Dirección frecuente</option>
                    </select>
                </div>
            </div>
            <div className="col-12 py-3 d-flex justify-content-center align-items-center">
                <button onClick={registrarDireccion} disabled={!datosCompletos} className="btn btn-primary">Registrar Dirección</button>
            </div>
        </div>
    </div>
    </>)

    //#endregion
}

// ======================================================================================================
//#region CONSTANTES
// ======================================================================================================
const URL_INSERTAR_DIRECCION = process.env.REACT_APP_URL_INSERTAR_DIRECCION;
//#endregion